import { USERDELETE_URLS, USERSTATUS_URLS } from '../../config/config'
import { UserAPICall } from './UserRequestUtil'

export const UserStatus = async (type,param) =>{
  const url = USERSTATUS_URLS[type];
  const parameter = {
    username: param.uid,
    isLock: !param.isAvailable
  }
  console.log("UserStatus",url,parameter)
  const res = await UserAPICall(url,parameter);

  return res;
};